import { create } from 'zustand';

import { Task } from '@/types/types';

interface TaskDrawerState {
  taskId: Task['id'] | null;
  initialTab?: string;
  open: (taskId: Task['id'], initialTab?: string) => void;
  close: () => void;
}

export const useTaskDrawerStore = create<TaskDrawerState>((set) => ({
  taskId: null,
  initialTab: undefined,
  open: (taskId, initialTab) => set({ taskId, initialTab }),
  close: () => set({ taskId: null, initialTab: undefined }),
}));
